/* eslint-disable @typescript-eslint/no-explicit-any */
import { CommonModule } from "@angular/common";
import { Component, inject, signal } from "@angular/core";
import { rxResource } from "@angular/core/rxjs-interop";
import { Router, RouterLink } from "@angular/router";
import { Capacitor } from "@capacitor/core";
import { CenterNoticeService } from "@malirang/api-client";
import {
    Icon,
    ModalService,
    SLIDE_X,
    ToastService,
} from "@malirang/front-share";
import { filter, tap } from "rxjs";
import { AlertService } from "../../../services/alert.service";
import { ChildStore } from "../../../stores/child.store";
import { UserStore } from "../../../stores/user.store";
import { MypageStore } from "../../my-page/store/my-page.store";

interface Item {
    title: string;
    icon: string;
    click: () => void;
}

@Component({
    selector: "app-side-menu",
    standalone: true,
    imports: [CommonModule, Icon, RouterLink],
    templateUrl: "./side-menu.component.html",
    styleUrl: "./side-menu.component.scss",
    animations: [SLIDE_X],
})
export default class SideMenuComponent {
    private readonly router = inject(Router);
    private readonly modalService = inject(ModalService);
    private readonly userStore = inject(UserStore);
    private readonly alertService = inject(AlertService);
    private readonly toastService = inject(ToastService);
    private readonly myPageStore = inject(MypageStore);
    private readonly centerNoticeService = inject(CenterNoticeService);
    private readonly childStore = inject(ChildStore);

    user = this.userStore.user;

    centerNoticeCount$ = rxResource({
        stream: () =>
            this.centerNoticeService
                .parentCenterNoticeControllerCountByParent({
                    childId: this.childStore.selectedChild$()?.id || "",
                    pageSize: 9999,
                })
                .pipe(
                    tap((res: number) => {
                        const found: any = this.menus?.find(
                            (menu) => menu.link === "/center-notice",
                        );
                        found["count"] = res;
                    }),
                ),
    });

    mainMenus = signal<Item[]>(
        Capacitor.isNativePlatform()
            ? [
                  {
                      title: "MY",
                      icon: "solar:user-circle-bold-duotone",
                      click: (ev?: Event) => {
                          this.close();
                          this.router.navigate(["/my-page"]);
                      },
                  },
                  {
                      title: "고객지원",
                      icon: "solar:call-chat-rounded-bold-duotone",
                      click: (ev?: Event) => {
                          this.close();
                          this.router.navigate([
                              "/customer",
                              {
                                  queryParams: {
                                      segment: "notice",
                                  },
                              },
                          ]);
                      },
                  },
                  {
                      title: "설정",
                      icon: "solar:settings-bold-duotone",
                      click: (ev?: Event) => {
                          this.myPageStore.setSelectedSegment("setting");
                          this.close();
                          this.router.navigate(["/my-page"]);
                      },
                  },
              ]
            : [
                  {
                      title: "MY",
                      icon: "solar:user-circle-bold-duotone",
                      click: (ev?: Event) => {
                          this.close();
                          this.router.navigate(["/my-page"]);
                      },
                  },
                  {
                      title: "장바구니",
                      icon: "solar:bag-4-bold-duotone",
                      click: () => {
                          this.close();
                          this.router.navigate(["/shopping-cart"]);
                      },
                  },
                  {
                      title: "고객지원",
                      icon: "solar:call-chat-rounded-bold-duotone",
                      click: (ev?: Event) => {
                          this.close();
                          this.router.navigate([
                              "/customer",
                              {
                                  queryParams: {
                                      segment: "notice",
                                  },
                              },
                          ]);
                      },
                  },
                  {
                      title: "설정",
                      icon: "solar:settings-bold-duotone",
                      click: (ev?: Event) => {
                          this.myPageStore.setSelectedSegment("setting");
                          this.close();
                          this.router.navigate(["/my-page"]);
                      },
                  },
                  {
                      title: "스토어",
                      icon: "material-symbols:shopping-bag",
                      click: () => {
                          this.close();
                          this.router.navigate(["/store"]);
                      },
                  },
              ],
    );

    menus = [
        {
            title: "발달센터 찾기",
            link: "/growth-center",
            iconName: "solar:map-point-search-bold-duotone",
        },
        {
            title: "센터 공지사항",
            count: 0,
            link: "/center-notice",
            queryParams: {
                segment: "notice",
            },
            iconName: "solar:document-add-bold",
        },
    ];

    close(): void {
        this.modalService.close();
    }

    /**
     * @name logout
     * @description 로그아웃
     * @param {Event} ev
     * @returns {void}
     */
    logout(ev?: Event): void {
        ev?.stopPropagation();
        this.alertService
            .open({
                icon: "completed",
                title: "로그아웃",
                message: "로그아웃을 하시겠습니까?",

                button: { label: "확인" },
            })
            .closed.pipe(filter((result) => result?.role === "confirm"))
            .subscribe({
                next: async () => {
                    await this.userStore.logout();
                    this.toastService.success("로그아웃 되었습니다.");
                    this.close();
                },
            });
    }
}
